import round from 'lodash/round';

export const formatAndRoundNumber = (number: number, decimalPlaces: number = 2): string =>
  round(number, decimalPlaces).toLocaleString('en-GB').replace(/,/g, ' ');
